import { get } from 'lodash';
import React from 'react';
import styled from 'styled-components';

import LogSkeleton, { SIZES } from '../LogSkeleton';
import { ValueOf } from '@utils/tsUtils';

interface CommunicationListSkeletonProps {
  className?: string;
  size: ValueOf<typeof SIZES>;
}

interface CommunicationListSkeletonState {
  itemCount: number;
}

class CommunicationListSkeleton extends React.PureComponent<
  CommunicationListSkeletonProps,
  CommunicationListSkeletonState
> {
  private wrapper: React.RefObject<HTMLDivElement>;

  defaultProps = {
    size: SIZES.MEDIUM,
  };

  constructor(props) {
    super(props);

    this.state = {
      itemCount: 0,
    };

    this.wrapper = React.createRef();
  }

  componentDidMount() {
    const wrapperSize = get(this.wrapper.current, 'clientHeight') || 0;
    const itemCount = Math.ceil(wrapperSize / 62);
    this.setState({ itemCount });
  }

  render() {
    const { itemCount } = this.state;
    const { size, ...props } = this.props;
    return (
      <StyledLogSkeleton ref={this.wrapper} {...props}>
        {[...Array(itemCount)].map(() => (
          <LogSkeleton size={size} />
        ))}
      </StyledLogSkeleton>
    );
  }
}

const StyledLogSkeleton = styled.div`
  height: 100%;
`;

export default CommunicationListSkeleton;
